import React from 'react';

import {EntryHistoryPanelState} from 'FileStates';
import {Entry} from 'notebook/entries/backbone/filestate/Entry';
import ReactPanelBaseView, {getTabAndPanelIds, Subpanel} from 'toolbar/ReactPanelBaseView';

import EntryHistoryPanel from './EntryHistoryPanel';

class EntryHistoryPanelView extends ReactPanelBaseView<EntryHistoryPanelState, Entry> {
  getSubpanels(): Array<Subpanel> {
    return [
      {
        ...getTabAndPanelIds('history'),
        title: 'History',
        hideInPanelTabs: true,
        component: (
          <EntryHistoryPanel
            id={this.model.id}
            folderId={this.model.folder()?.api_identifier}
            name={this.model.name()}
            permissions={this.model.permissions()}
          />
        ),
      },
    ];
  }
}

export default EntryHistoryPanelView;
